import {
  WSControl,
  WSForm,
  WSInfoBox,
  WSInputText,
  WSList
} from "@wingspanhq/fe-component-library";
import React from "react";

import { FormPartialAddress } from "../../Onboarding/components/FormPartialAddress";
import { WORKSITE_COUNTRY } from "../types";

/**
 * The work site fields shared by the create and edit modals — they collect the
 * exact same payload, only the title and the submit label differ.
 */
export const FormPartialWorksite: React.FC = () => (
  <WSList gap="L">
    <WSForm.Field
      name="name"
      label="Work site name"
      component={WSInputText}
      componentProps={{
        placeholder: "Work site name",
        required: true
      }}
    />

    <FormPartialAddress
      country={WORKSITE_COUNTRY}
      name="address"
      label="Work site address"
    />

    <WSForm.Field
      name="externalId"
      label="External ID (optional)"
      component={WSInputText}
      componentProps={{ placeholder: "External ID" }}
    />

    <WSList gap="M">
      <WSForm.Field
        name="isPrimary"
        component={WSControl}
        componentProps={{
          type: "checkbox",
          label: "Mark as primary work site (optional)"
        }}
      />
      <WSInfoBox theme="neutral" transparent={false}>
        Used as a fallback address in rare cases. Mark this as headquarters to
        set it as the physical address. This overrides any other work site
        currently marked as primary.
      </WSInfoBox>
    </WSList>
  </WSList>
);
